import React, { useContext, useState } from 'react'
import { Context } from '../../Context/Context'
import { DEFAULTAVATAR } from '../../Constants';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import MiniAvatarModal from 'Modals/MiniAvatarModal';
import { ChevronDown } from 'lucide-react';

function MiniAvatar({size = null}) {
    const {userDetails} = useContext(Context);
    const {profilePic} = userDetails;
    const navigate = useNavigate();
    // No uploaded photo -> first/last initials on a gold circle instead of the stock avatar
    const hasPic = profilePic && profilePic !== "";
    const initials = ((userDetails?.firstName?.[0] || "") + (userDetails?.lastName?.[0] || "")).toUpperCase();

    const [showOptions, setShowOptions] = useState(false);
    const signOutFunc = async() => {
      try {
        const signout = await signOut();
          localStorage.clear();
          navigate("/");
      }
      catch(error)
      {
        console.log(error);
      }
        
    }
  return (
    <div className={'flex items-center justify-center relative' + (size ? '' : ' lg:w-[70px]')}>
        {size ?
        <div className='flex items-center gap-1 cursor-pointer' onClick={()=>setShowOptions((prev) => !prev)}>
          <div className='rounded-full overflow-hidden flex-none flex items-center justify-center'
          style={{width: size + 'px', height: size + 'px', background: hasPic ? 'rgba(247,244,237,.14)' : '#c9a26a', border: hasPic ? '1px solid rgba(247,244,237,.22)' : 'none', color:'#14213d', font:"600 " + Math.round(size * 0.4) + "px/1 'IBM Plex Sans',sans-serif"}}
          >
              {hasPic ? <img className='w-full h-full object-cover' src={profilePic} alt="Preview" /> : (initials || <img className='w-full h-full object-cover' src={DEFAULTAVATAR} alt="Preview" />)}
          </div>
          <ChevronDown size={14} strokeWidth={2} color="rgba(247,244,237,.6)" />
        </div>
        :
        <div className={'flex mx-4 lg:w-10 lg:h-10 w-6 h-6 border ring-2 rounded-full ring-gray-400' + (userDetails.verified ? ' ring-green-600' : '')}
        onClick={()=>setShowOptions((prev) => !prev)}
        >
            {hasPic || !initials
              ? <img src={hasPic ? profilePic : DEFAULTAVATAR} alt="Preview" />
              : <div className='w-full h-full rounded-full flex items-center justify-center text-[10px] lg:text-sm' style={{background:'#c9a26a', color:'#14213d', fontWeight:600, fontFamily:"'IBM Plex Sans',sans-serif"}}>{initials}</div>}
        </div>
        }
        {showOptions &&
          <MiniAvatarModal onClose={()=>setShowOptions(false)} uploadNew={showOptions} />
        }
    </div>
  )
}

export default MiniAvatar